__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "digi-pweb-edocuments";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@athena-ui-components/axios", "0.8.27", () => (__webpack_require__.e(170).then(() => (() => (__webpack_require__(2170))))));
			register("@athena-ui-components/helpers", "1.1.26", () => (Promise.all([__webpack_require__.e(546), __webpack_require__.e(995), __webpack_require__.e(860), __webpack_require__.e(725), __webpack_require__.e(723)]).then(() => (() => (__webpack_require__(7553))))));
			register("@dbs/design-tokens", "0.7.67", () => (__webpack_require__.e(11).then(() => (() => (__webpack_require__(1011))))));
			register("@dbs/loaders", "2.2.8", () => (Promise.all([__webpack_require__.e(789), __webpack_require__.e(736), __webpack_require__.e(995), __webpack_require__.e(860), __webpack_require__.e(104)]).then(() => (() => (__webpack_require__(4736))))));
			register("@dbs/modals", "3.0.5", () => (Promise.all([__webpack_require__.e(290), __webpack_require__.e(130), __webpack_require__.e(995), __webpack_require__.e(860), __webpack_require__.e(717), __webpack_require__.e(656)]).then(() => (() => (__webpack_require__(1290))))));
			register("@webstudio/analytics", "3.14.0", () => (Promise.all([__webpack_require__.e(38), __webpack_require__.e(630), __webpack_require__.e(982)]).then(() => (() => (__webpack_require__(9038))))));
			register("@webstudio/dispatcher", "0.1.1", () => (__webpack_require__.e(537).then(() => (() => (__webpack_require__(2537))))));
			register("history", "4.10.1", () => (__webpack_require__.e(330).then(() => (() => (__webpack_require__(949))))));
			register("i18next", "23.16.8", () => (__webpack_require__.e(32).then(() => (() => (__webpack_require__(5032))))));
			register("react-dom", "17.0.2", () => (Promise.all([__webpack_require__.e(998), __webpack_require__.e(995)]).then(() => (() => (__webpack_require__(9998))))));
			register("react-i18next", "13.5.0", () => (Promise.all([__webpack_require__.e(995), __webpack_require__.e(85)]).then(() => (() => (__webpack_require__(5085))))));
			register("react-i18next", "14.1.3", () => (Promise.all([__webpack_require__.e(923), __webpack_require__.e(995)]).then(() => (() => (__webpack_require__(9923))))));
			register("react-redux", "7.2.9", () => (Promise.all([__webpack_require__.e(402), __webpack_require__.e(995), __webpack_require__.e(717), __webpack_require__.e(315)]).then(() => (() => (__webpack_require__(2402))))));
			register("react", "17.0.2", () => (__webpack_require__.e(483).then(() => (() => (__webpack_require__(2483))))));
			register("redux-injectors", "1.3.0", () => (Promise.all([__webpack_require__.e(995), __webpack_require__.e(531), __webpack_require__.e(502)]).then(() => (() => (__webpack_require__(5502))))));
			register("redux-saga", "1.1.3", () => (__webpack_require__.e(497).then(() => (() => (__webpack_require__(6497))))));
			register("redux", "4.1.0", () => (__webpack_require__.e(266).then(() => (() => (__webpack_require__(8266))))));
			register("styled-components", "5.3.11", () => (Promise.all([__webpack_require__.e(640), __webpack_require__.e(995)]).then(() => (() => (__webpack_require__(640))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};